<template>
  <div id="layout_main">
    <div id="layout_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Auth'
  }
</script>

<style scoped>
  #layout_main{
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  #layout_content{
    display: flex;
    margin-top: -200px;
  }
</style>
